import useGetter from "./useGetter";

export default function useAllPlayers() {
  const { data: playersData, query: playersQuery } = useGetter(`/players/all`, {
    staleTime: 2 * 60 * 60 * 1000,
  });

  return { playersData, playersQuery };
}
